import Deductions from './Deductions';

export default Deductions;
